import {
  FormField,
  DynamicFormConfig,
} from '../components/forms/dynamic-form/models/dynamic-form.model';
import { LookupItem } from '../models/account.model';
import { BaseFormConfig } from '../../core/base-configs/base-form.config';

export const DEFAULT_LANGUAGES: LookupItem[] = [{ id: 1, name: 'English' }];

export const DEFAULT_SHORT_TIMES: LookupItem[] = [
  { id: 1, name: '09:40 AM' },
  { id: 2, name: '9:40 AM' },
  { id: 3, name: '9:40' },
  { id: 4, name: '09:40' },
];

export class AccountFormConfig extends BaseFormConfig {
  static getFirstNameField(): FormField {
    return {
      id: 'firstName',
      controlType: 'input',
      formControlName: 'firstName',
      config: {
        label: 'First Name',
        placeholder: 'Enter first name',
        type: 'text',
      },
      validation: {
        required: true,
        maxLength: 100,
        errorMessages: {
          required: 'First name is required',
          maxLength: 'First name cannot exceed 100 characters',
        },
      },
      gridPosition: { colSpan: 6 },
    };
  }

  static getLastNameField(): FormField {
    return {
      id: 'lastName',
      controlType: 'input',
      formControlName: 'lastName',
      config: {
        label: 'Last Name',
        placeholder: 'Enter last name',
        type: 'text',
      },
      validation: {
        required: true,
        maxLength: 100,
        errorMessages: {
          required: 'Last name is required',
          maxLength: 'Last name cannot exceed 100 characters',
        },
      },
      gridPosition: { colSpan: 6 },
    };
  }

  static getEmailField(): FormField {
    return {
      id: 'email',
      controlType: 'input',
      formControlName: 'email',
      config: {
        label: 'Email',
        placeholder: 'Enter email address',
        type: 'email',
        disabled: true,
      },
      validation: {
        required: true,
        pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
        errorMessages: {
          required: 'Email is required',
          pattern: 'Please enter a valid email address',
        },
      },
      gridPosition: { colSpan: 6 },
    };
  }

  static getLanguageField(languages: LookupItem[] = DEFAULT_LANGUAGES): FormField {
    return {
      id: 'language',
      controlType: 'select',
      formControlName: 'language',
      config: {
        label: 'Language',
        placeholder: 'Select language',
        data: languages,
        valuePrimitive: true,
        valueField: 'id',
        textField: 'name',
      },
      validation: {
        required: true,
        errorMessages: {
          required: 'Language is required',
        },
      },
      gridPosition: { colSpan: 6 },
    };
  }

  static getTimezoneField(timezones: LookupItem[] = []): FormField {
    return {
      id: 'timeZone',
      controlType: 'select',
      formControlName: 'timeZone',
      config: {
        label: 'Timezone',
        placeholder: 'Select timezone',
        data: timezones,
        valuePrimitive: true,
        valueField: 'id',
        textField: 'name',
      },
      validation: {
        required: false,
        errorMessages: {},
      },
      gridPosition: { colSpan: 12 },
    };
  }

  static getShortTimeField(shortTimes: LookupItem[] = DEFAULT_SHORT_TIMES): FormField {
    return {
      id: 'shortTime',
      controlType: 'select',
      formControlName: 'shortTime',
      config: {
        label: 'Short Time',
        placeholder: 'Select time format',
        data: shortTimes,
        valuePrimitive: true,
        valueField: 'id',
        textField: 'name',
      },
      validation: {
        required: false,
        errorMessages: {},
      },
      gridPosition: { colSpan: 12 },
    };
  }

  static getEditConfig(
    timezones: LookupItem[] = [],
    languages: LookupItem[] = DEFAULT_LANGUAGES,
    shortTimes: LookupItem[] = DEFAULT_SHORT_TIMES
  ): DynamicFormConfig {
    return this.createFormConfig({
      sections: [
        {
          id: 'main',
          title: '',
          fields: [
            this.getFirstNameField(),
            this.getLastNameField(),
            this.getEmailField(),
            this.getLanguageField(languages),
            this.getTimezoneField(timezones),
            this.getShortTimeField(shortTimes),
          ],
          layout: { type: 'grid' as const, columns: 2 },
        },
      ],
      submitText: 'Submit',
      cancelText: 'Cancel',
      validateOnSubmit: true,
      validateOnBlur: true,
    });
  }
}
